module.exports = __webpack_public_path__ + "static/img/offical13.d0b1715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinus/offical13.jpg
// module id = N1gO
// module chunks = 18